import React, { Suspense } from 'react'
import RoutesAttendance from './RoutesAttendance'
import RoutesBasicInfo from './RoutesBasicInfo'
import RoutesESystem from './RoutesESystem'
import RoutesHome from './RoutesHome'
import RoutesInsurance from './RoutesInsurance'
import RoutesManagement from './RoutesManagement'
import RoutesSalary from './RoutesSalary'
import RoutesTerminal from './RoutesTerminal'

import MainLayout from 'components/layout/main-layout/MainLayout'
import NavigationScroll from 'components/layout/NavigationScroll'
import PopupLayout from 'components/layout/popup-layout/PopupLayout'
// import AttendanceAdd from 'pages/attend/AttendanceAdd'

import { Outlet } from 'react-router-dom'
import { AUTH_ACCESS } from './PermissionsRoutes'

// Lazy load components with their CSS
const Faq = React.lazy(() => import(/* webpackChunkName: "faq" */ 'pages/common/Faq'))
const ServiceInfo = React.lazy(() => import(/* webpackChunkName: "service-info" */ 'pages/common/ServiceInfo'))
const Forbidden = React.lazy(() => import(/* webpackChunkName: "forbidden" */ 'pages/common/Forbidden'))
const NotFound = React.lazy(() => import(/* webpackChunkName: "not-found" */ 'pages/common/404'))

const AttendanceAdd = React.lazy(() => import(/* webpackChunkName: "attendance-add" */ 'pages/attend/AttendanceAdd'))
const Test = React.lazy(() => import(/* webpackChunkName: "test" */ 'pages/common/Test'))
const Login = React.lazy(() => import(/* webpackChunkName: "login" */ 'pages/login/Login'))
const MobileLogin = React.lazy(() => import(/* webpackChunkName: "login" */ 'pages/login/MobileLogin'))

const Privacy = React.lazy(() => import(/* webpackChunkName: "privacy" */ 'pages/common/privacy'))
const Home = React.lazy(() => import(/* webpackChunkName: "home" */ 'pages/common/Home'))

// Loading component with spinner
const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    Loading...
  </div>
);

// ErrorBoundary 컴포넌트 추가
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary: ", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

const routes = [
  {
    path: '/', exact: true, name: '홈',
    element: <NavigationScroll><MainLayout /></NavigationScroll>,
    children: [
      { path: '/faq', exact: true, name: '자주 묻는 질문', element: <Suspense fallback={<LoadingSpinner />}><Faq /></Suspense> },
      { path: '/service-info', exact: true, name: '서비스 소개', element: <Suspense fallback={<LoadingSpinner />}><ServiceInfo /></Suspense> },
      { path: '/forbidden', exact: true, name: '권한없음', element: <Suspense fallback={<LoadingSpinner />}><Forbidden /></Suspense> },
      { path: '/404', exact: true, name: '경로없음', element: <Suspense fallback={<LoadingSpinner />}><NotFound /></Suspense> },
      { path: '/privacy', exact: true, name: '개인정보 처리방침', element: <Suspense fallback={<LoadingSpinner />}><Privacy /></Suspense> },
    ]
  },
  {
    path: '/', exact: true, name: '홈',
    element: <NavigationScroll><MainLayout /></NavigationScroll>,
    ...AUTH_ACCESS,
    children: [
      { path: '', exact: true, name: '홈', element: <Suspense fallback={<LoadingSpinner />}><Home /></Suspense> },
      ...RoutesHome,
      ...RoutesManagement,
      ...RoutesBasicInfo,
      ...RoutesTerminal,
      ...RoutesAttendance,
      ...RoutesSalary,
      ...RoutesInsurance,
      ...RoutesESystem,
      { path: '/test', exact: true, name: '연차 계산 테스트', element: <Suspense fallback={<LoadingSpinner />}><Test /></Suspense> },
      { path: '/faq', exact: true, name: '자주 묻는 질문', element: <Suspense fallback={<LoadingSpinner />}><Faq /></Suspense> },
      { path: '/service-info', exact: true, name: '서비스 소개', element: <Suspense fallback={<LoadingSpinner />}><ServiceInfo /></Suspense> },
      { path: '/forbidden', exact: true, name: '권한없음', element: <Suspense fallback={<LoadingSpinner />}><Forbidden /></Suspense> },
      { path: '/404', exact: true, name: '경로없음', element: <Suspense fallback={<LoadingSpinner />}><NotFound /></Suspense> },
      { path: '/privacy', exact: true, name: '개인정보 처리방침', element: <Suspense fallback={<LoadingSpinner />}><Privacy /></Suspense> },
      { path: '*', exact: true, name: '알 수 없는 경로', element: <Suspense fallback={<LoadingSpinner />}><NotFound /></Suspense> }
    ]
  },
  {
    path: '/', element: <ErrorBoundary><Suspense fallback={<LoadingSpinner />}><Outlet /></Suspense></ErrorBoundary>,
    children: [
      { path: '/login', exact: true, name: '로그인페이지', element: <Suspense fallback={<LoadingSpinner />}><Login /></Suspense> },
      { path: '/mobilelogin', exact: true, name: '모바일로그인페이지', element: <Suspense fallback={<LoadingSpinner />}><MobileLogin /></Suspense> },
      // { path: '/password-forgot', exact: true, name: '비밀번호 찾기', element: <Login /> },
    ]
  },

  // {
  //     path: '', exact: true, name: '홈', element: <NavigationScroll><MainLayout /></NavigationScroll>,
  //     children: [
  //         // { path: '/login', exact: true, name: '로그인페이지', element: <Login /> },
  //         // { path: '/password-forgot', exact: true, name: '비밀번호 찾기', element: <Login /> },
  //     ]
  // },
  {
    path: '', exact: true, name: '팝업',
    element: <Suspense fallback={<LoadingSpinner />}><PopupLayout /></Suspense>,
    children: [
      // 팝업 대신 다이얼로그를 사용하므로 이 라우트는 제거
      // { path: '/attendance/management/write/:companyNo/:employeeNo', exact: true, name: '일 근태 정보 추가', element: <AttendanceAdd />, ...ADMIN_ACCESS },
    ]
  },

]

export default routes

